// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","vGray2":"#f4f5f7","tablet-landscape-up":"(min-width: calc(1024 * 1px))","desc":"PostContentText_desc__NV4vA","text":"PostContentText_text__3WNnp"};